// import "./App.css";

// function App() {
//   return (
//     <main className="flex justify-center gap-4 flex-col min-h-screen">
//       <h1 className="text-3xl text-center font-bold underline">
//         React & Tailwind CSS Starter Pack
//       </h1>
//       <p className="text-center text-xl">
//         This is a starter pack for React & Tailwind CSS projects.
//       </p>
//       <img src="https://bit.ly/3wsmzTy" alt="meme" className="mx-auto" />
//     </main>
//   );
// }

// export default App;

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import AboutUs from "./components/AboutUs";
import OurExpertise from "./components/OurExpertise";
import GetInTouch from "./components/GetInTouch";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-expertise" element={<OurExpertise />} />
        <Route path="/get-in-touch" element={<GetInTouch />} />
      </Routes>
    </Router>
  );
};

export default App;
